import type { FillBookingDetailsResponse, ProviderOrderResponse } from "@przezmorze/api-types";
import { przezmorzeApi } from "../../api/api";

export type { FillBookingDetailsResponse, ProviderOrderProduct, ProviderOrderResponse } from "@przezmorze/api-types";

export async function getProviderOrder(orderId: string, signal: AbortSignal) {
  const response = await przezmorzeApi.get<ProviderOrderResponse>(`/orders/${orderId}`, { signal });
  return response.data;
}

export async function fillBookingDetails(orderId: string, formData: FormData) {
  const response = await przezmorzeApi.post<FillBookingDetailsResponse>(`/orders/${orderId}/bookings`, formData);
  return response.data;
}
